import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Validators, UntypedFormBuilder} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import {Store} from '@ngrx/store';
import * as fromApp from './../../store/app.reducer';
import * as AuthActions from './../store/auth.actions';
import { customEmailValidator } from '../../shared/validators/email.validator';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false,
})
export class ForgotPasswordComponent implements OnInit {
    public formSubmitted: boolean = false;

    public forgotPasswordForm = this.formBuilder.group({
        email: ['', [Validators.required, customEmailValidator()]],
    });

    constructor(
        private location: Location,
        private formBuilder: UntypedFormBuilder,
        private translate: TranslateService,
        private store: Store<fromApp.AppState>
    ) { }

    ngOnInit(): void {
        this.setupFormValidation();
    }

    get email() {
        return this.forgotPasswordForm.get('email');
    }

    private setupFormValidation(): void {
        this.forgotPasswordForm.valueChanges.subscribe(() => {
            if (this.formSubmitted) {
                this.validateForm();
            }
        });
    }

    private validateForm(): void {
        if (this.forgotPasswordForm.valid) {
            this.formSubmitted = true;
            return;
        }
    }

    public shouldShowError(controlName: string): boolean {
        const control = this.forgotPasswordForm.get(controlName);
        return Boolean((control?.touched || this.formSubmitted) && control?.errors);
    }

    public getErrorMessage(controlName: string): string {
        const control = this.forgotPasswordForm.get(controlName);
        if (!control || !control.errors) return '';

        const errors = control.errors;
        const controlNameCapitalized = controlName.charAt(0).toUpperCase() + controlName.slice(1);

        if (errors['required']) {
            return `${controlNameCapitalized} ${this.translate.instant('form.validation.required')}`;
        }
        if (errors['email']) {
            return this.translate.instant('form.validation.email');
        }
        return '';
    }

    public onSubmit(): void {
        this.formSubmitted = true;
        if (this.forgotPasswordForm.valid) {
            const formData = {
                email: this.email.value,
            };
            this.store.dispatch(new AuthActions.ForgotPasswordStart(formData));
        } else {
            this.formSubmitted = false;
            Object.keys(this.forgotPasswordForm.controls).forEach(key => {
                const control = this.forgotPasswordForm.get(key);
                control?.markAsTouched();
            });
        }
    }

    goBack(): void {
        this.location.back();
    }
}